import { InputWrapper, MantineThemeOverride } from '@mantine/core';
import { classNames } from '@uag/react-core';

export const getCustomThemeOverrides = (): MantineThemeOverride => ({
    components: {
        InputBase: {
            classNames: classNames.textField.default
        },
        InputWrapper: InputWrapper.extend({
            classNames: {
                required: 'text-text-alert -ml-1'
            }
        })
    }
});
